import ApiRequests from '@/api/ApiRequests'

const state = {
  organization: {},
  site: {},
  user: {
    memberships: {
      organizations: [],
      sites: []
    }
  }
}

const getters = {
  selectedOrganization: state => state.organization,
  selectedSite: state => state.site,

  isOrgAdmin: function (state) {
    return state.user.memberships.organizations.length > 0 || state.user.memberships.superAdmin
  },

  isOrganizationSelected: function (state) {
    return state.organization._id !== undefined
  },

  isSiteSelected: function (state) {
    return state.site._id !== undefined
  },

  getUser: state => state.user
}

const mutations = {
  setOrganization (state, org) {
    if (state.organization._id !== org._id) {
      state.organization = org
      state.site = {}
    }
  },

  setSite (state, d) {
    state.site = d
  },

  setUser (state, d) {
    state.user = d
  }
}

const actions = {
  actionGetUser (context) {
    ApiRequests.userGet('me').then(r => {
      var user = r.data
      context.commit('setUser', user)
    }).catch(e => {
      console.log(e)
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
